var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({ref:"editable",staticClass:"clean-input",class:_vm.hasError ? 'is-invalid' : '',attrs:{"contenteditable":"","placeholder":_vm.placeholder},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();}}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }